import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getSafePerceptionInfo } from "./common/services";

export function safePerceptionLoader() {
  return defer({
    coreData: resolveLoaderResult(getSafePerceptionInfo()),
  });
}
